import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { TaskViewElementEnum } from "@/components/tasks-kanban/enums";
import { ListItemModel } from "../../../models";
import { computed, CSSProperties, PropType } from "vue";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-item-wrapper',
  props: {
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



/**Стиль компонента */
const componentStyle = computed<CSSProperties>(() => ({
  width: props.element.Width,
  minWidth: props.element.MinWidth,
  flexShrink: props.element.MinWidth ? "0" : "1",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "task-card-item-wrapper",
    style: _normalizeStyle(componentStyle.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})